export const IncognitoType = {
    DEFAULT: 'DEFAULT',
    GOVERNMENT: 'GOVERNMENT',
};
//# sourceMappingURL=types.js.map